
<template>
  <div class="container feedback template-bg-gray" v-bind:class="{'my-position-relative': isStatus}">
    <md-card class="request-status loop_container bg-transparent update-request-form-common" v-if="isStatus">
      <md-card-content class="col-lg-12 col-md-12 col-sm-12 col-xs-12 main">
        <div class="card form-wrapper text-center p-20">
          <h4 class="template-custom-title" v-html="statusMsg"></h4>
        </div>
      </md-card-content>
    </md-card>
    <div class="row " v-if="!isStatus">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 main-sec">
        <div class="loop_container bg-transparent  update-request-form-common">
          <div class="card form-wrapper" v-bind:class="{'thankupageplr88': success}">
            <div class="feedback_container feedback_newupdate">
              <div class="community-logo">
                <img :src="logoURL" class="top-logo custom-logo" :alt="'Community Logo of '+ community.content.parameter4">
              </div>
              <div class='common-space-from-logo my-text-center' v-bind:class="{'email-actionpage-tmsg plr10': !success}">
                <h1 id="main-header" class="template-title" aria-live="polite">Thank you!</h1>
                <p class="custom-content my-text-center" v-if="!success" aria-live="polite">We really appreciate your feedback!</p>
              </div>
              <form @submit.prevent="updateFeedback()"  v-show="!success" class="template-form">
                <p class="required-note template-label" id="required-note">
                  Fields marked with an asterisk (<span class="required-symbol">*</span>) are required.
                </p>
                <div class="row ">
                  <div class="col-md-12 ">
                    <div :class="[{'b-error' : errors.has('comment')}, 'form-group', 'pd-remove', 'unsubscribe-height']" class="input-group pd-remove unsubscribe-height input-focus request-form-question-container template-input-text-area common-question-textarea-for-v1-v2">
                      <div class="char-counter-input">
                        <span id="char-counter-feedback" aria-live="polite">{{remainingCount}} / {{max}} <span class="sr-only"> character count </span></span>
                        <span class="required-symbol"> *</span>
                      </div>
                      <textarea
                        @blur="handleBlur"
                        @focus="handleFocus"
                        aria-label="Character count available for this textarea"
                        id="comment"
                        class="form-control placeholder-bold"
                        name="comment"
                        rows="10"
                        v-model="comment"
                        :placeholder="commentPlaceholder"
                        v-validate="'required|max:500'"
                        v-on:keyup="countdown"
                        :maxlength="max"
                        aria-required="true"
                        v-bind:class="{'request-form-error-border': errors.has('comment') }"
                        @input="e => comment = sanitizeInput(e.target.value)"
                      ></textarea>
                      <div class="form-group  pd-remove unsubscribe-btn mb-0-custom">
                        <div class="char-counter template-subject-counter"
                          v-bind:class="{'char-count-error': exceedsMaxCount }"
                        >{{remainingCount}}  / 500</div>
                      </div>
                    </div>
                  </div>
                </div>
                <span v-if="errors.has('comment')" class="error">
                  {{ errors.first('comment') }}
                </span>
                <div class="row mlr0" v-if="community.content.testimonialConsent">
                  <div class="form-group disclaimer">
                    <label class="template-checkbox pt-0">
                      <input
                        type="checkbox"
                        name="testimonialConsent"
                        id="testimonialConsent"
                        v-model="testimonialConsent"
                      />
                      <span v-html="community.content.testimonialConsentMessage"></span>
                    </label>
                  </div>
                </div>
                                            <div class="col-md-12 text-right">
                                                <div class="form-group pd-remove unsubscribe-btn">
                                                    <button type="submit"
                                                        name="helpAction"
                                                        v-bind:style="reviewBtn"
                                                        class="btn btn_info template-review-submit template-button template-button-width">Submit</button>
                                                </div>
                                            </div>
                            </form>
							<div v-show="!success" class="m-top-34">
                                <div class="row my">
                                    <div class="col-md-12">
                                        <h2 class="text-center email-request-title">FYI, here's the {{feedback}}</h2>
                                    </div>
                                </div>
								<template v-if="feedback === 'request'">
                                    <div class="email-request-review">
                                        <div class="template-request-review">
                                            <span id="feedback-name" v-if="createdByMember.first && createdByMember.last">{{ createdByMember.first + ' ' +  createdByMember.last }}</span>
                                            <br>
                                            <span id="feedback-email" v-if="$lodash.has(createdByMember.emails, 0)">{{createdByMember.emails[0]}}
                                            </span>
                                            <br><br>
                                            <span id="feedback-name">{{ask.subject}}</span>
                                            <br>
                                            <p class="font-color">{{askDetail}}</p>
                                        </div>
                                    </div>
                                </template>
								<template v-if="giveID && feedback === 'response'">
                                    <div class="email-request-review">
                                        <div class="template-request-review">
                                            <h2 v-if="advisorDetails.first && advisorDetails.last">{{ advisorDetails.first + ' ' +  advisorDetails.last }}</h2>
                                            <h5 v-if="$lodash.has(advisorDetails.emails, 0)">{{advisorDetails.emails[0]}}</h5>
											<h5 v-else-if="givesEmail">{{givesEmail}}</h5>
                                            <h6>{{giveDate}}</h6>
                                            <p class="font-color" v-html="giveText"></p>
                                        </div>
                                    </div>
                                </template>
							</div>
            </div>
          </div>
          <ul class="list-inline text-center footer-links">
            <li>
              <a :href="community.content.landingPageURL" target="_blank" class="links" v-if="community.content && community.content.landingPageURL && community.content.landingPageURL.length" tabindex="0">Learn More</a>
              <a href="javascript:void(0)" v-else tabindex="0">Learn More</a>
            </li>
            <li>
              <a :href="community.content.termsConditionsURL" target="_blank" class="links" v-if="community.content && community.content.termsConditionsURL && community.content.termsConditionsURL.length" tabindex="0">Terms Of Use</a>
              <a href="javascript:void(0)" v-else tabindex="0">Terms Of Use</a>
            </li>
            <li>
              <a tabindex="0" :href="community.content.unsubscribePageURL" target="_blank" v-if="community.content && community.content.unsubscribePageURL && community.content.unsubscribePageURL.length">Opt Out</a>
              <a href="javascript:void(0)" v-else>Opt Out</a>
            </li>
          </ul>
          <div class="unsubscribe-community-logo">
            <a :href="(community.content && community.content.landingPageURL) || 'https://www.protopia.co'" target="_blank"><img :src="footerLogoURL" :alt="'Community Logo of '+ community.content.parameter4"></a>
            <span class="sr-only">Protopia - Visit our site</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import API from "../services/API";
import { getFooterURL, getLogoURL } from "../helpers/getCustomSettings";
import { sanitizeInput } from '../utils/sanitizer';

export default {
  props: ["communityId", "askID", "giveID", "num", "feedback"],
  data() {
    return {
      api: new API(),
      ask: {},
      give: {},
      createdByMember: {},
      community: {},
      email: "",
      comment: "",
      giveText: "",
      success: false,
      exceedsMaxCount: false,
      max: 500,
      remainingCount: 0,
      askDetail: "",
      advisorDetails: {},
      giveDate: "",
      commentPlaceholder: "",
      givesEmail: "",
      feedbackId: "",
      testimonialConsent: false,
      pushId: "",
      _hasSubmittedInitialFeedback: false,
      reviewBtn: {
        'background-color': '#9178A0',
        'color': '#ffffff'
      },
      isStatus: true,
      statusMsg: '',
      logoURL: "",
      footerLogoURL: ""
    };
  },
  created() {
    if (!this.feedback) {
      this.$router.push('/');
    };
    if (this.feedback === 'request' && typeof this.askID === 'undefined') {
      this.$router.push('/');
    } else if (this.feedback === 'request' && this.askID === 'null') {
      this.$router.push('/');
    } else if (this.feedback === 'request' && this.askID === 'undefined') {
      this.$router.push('/');
    } else if (this.feedback === 'response' && typeof this.giveID === 'undefined') {
      this.$router.push('/');
    } else if (this.feedback === 'response' && this.giveID === 'null') {
      this.$router.push('/');
    } else if (this.feedback === 'response' && this.giveID === 'undefined') {
      this.$router.push('/');
    } else if (this.num < 0 || this.num > 10 || this.num === '' || typeof this.num === 'undefined') {
      this.$router.push('/');
    }
    this.loadData();
    const dict = {
      custom: {
        feedback_email: {
          required: 'Email address is required',
          email: 'Please enter valid email address',
          max: 'email address may not be greater than 60 characters'
        },
        comment: {
          required: 'Please enter feedback to be shared'
        },
        testimonialConsent: {
          required: 'You must agree to the testimonial consent'
        }
      }
    };
    this.$validator.localize('en', dict);
  },
  mounted() {
    this.$nextTick(() => {
      const heading = document.getElementById('main-header');
      if (heading) {
        heading.setAttribute('tabindex', '-1');
        heading.focus();
      }
    });
  },
  methods: {
    handleBlur() {
      this.commentPlaceholder = "[Click here to edit]\nTell us why you chose that rating. Note that both your rating and comment will remain confidential.";
      if (this.num >= 8) {
        this.commentPlaceholder = "[Click here to edit]\nWe get great feedback on {{ community.parameter1 }} and we're trying to show just how helpful of a tool it can be. Would you be willing to share a quick testimonial on your experience that we can share with others? Just 2-3 sentences would be incredibly helpful for us to get the word out. Thank you."

        if (this.ask.community.content && this.ask.community.content.feedbackRequestMessage) {
          this.commentPlaceholder = "[Click here to edit]\n" + this.ask.community.content.feedbackRequestMessage;
        }
        this.commentPlaceholder = this.commentPlaceholder.replace("{{ community.parameter1 }}", this.ask.community.content.parameter1 || '');
      }
    },
    handleFocus() {
      this.commentPlaceholder = '';
    },
    sanitizeInput(input) {
      return sanitizeInput(input);
    },
    loadData: async function() {
      if (this.askID) {
        localStorage.setItem('community_id', this.communityId);
        await this.$nextTick(); // Ensure localStorage is committed before API calls
        await this.api.get(`asks/${this.askID}`).then(async ask => {
          this.ask = ask.data;

          if (this.ask.status === '(8) Rejected' || this.ask.status === '(7) Closed') {
            // console.log("this.community :", this.ask.community);
            let closeMessage = this.ask.community.content.closeRequestMessage;
            this.statusMsg = closeMessage;
          } else {
            this.isStatus = false;
          }
          if (this.ask && this.isStatus == false) {
            this.commentPlaceholder = "[Click here to edit]\nTell us why you chose that rating. Note that both your rating and comment will remain confidential.";
            if (this.num >= 8) {
              this.commentPlaceholder = "[Click here to edit]\nWe get great feedback on {{ community.parameter1 }} and we're trying to show just how helpful of a tool it can be. Would you be willing to share a quick testimonial on your experience that we can share with others? Just 2-3 sentences would be incredibly helpful for us to get the word out. Thank you."

              if (this.ask.community.content && this.ask.community.content.feedbackRequestMessage) {
                this.commentPlaceholder = "[Click here to edit]\n" + this.ask.community.content.feedbackRequestMessage;
              }
              this.commentPlaceholder = this.commentPlaceholder.replace("{{ community.parameter1 }}", this.ask.community.content.parameter1 || '');
            }
            this.askDetail = this.ask.text;
            this.community = this.ask.community;
            const customSettings = this.community.customSettings;
            this.logoURL = getLogoURL(customSettings);
            this.footerLogoURL = getFooterURL(customSettings);
            this.reviewBtn = {
              'background-color': this.community.customSettings.primaryBtnBgColor,
              'color': this.community.customSettings.primaryTxtColor
            };
            /*insert feedback when user comes from email , and on submit update that feedback with comment*/
            // Only submit initial feedback once, not on every loadData() call
            // Use sessionStorage to prevent duplicate submissions even if component remounts
            const feedbackKey = `feedback_submitted_${this.feedback}_${this.askID || this.giveID}_${this.num}`;
            const hasSubmitted = sessionStorage.getItem(feedbackKey);
            
            if (!hasSubmitted) {
              await this.submitFeedback();
              sessionStorage.setItem(feedbackKey, 'true');
            }
            /*insert feedback when user comes from email , and on submit update that feedback with comment*/
            this.createdByMember = this.ask.createdByMemberID;
            if (this.giveID && this.feedback === 'response') {
              this.giveText = this.ask.gives.find(give => give._id === this.giveID).insight;
              var advisorId = this.ask.gives.find(give => give._id === this.giveID).advisors[0];
              if (typeof advisorId === 'undefined') {
                this.givesEmail = this.ask.gives.find(give => give._id === this.giveID).email;
              }
              await this.api.get(`members/${advisorId}`).then(member => {
                this.advisorDetails = member.data;
                var giveData = this.ask.gives.find(
                  give => give._id === this.giveID
                );
                var action = giveData.action;
                var insight = giveData.insight;
                if (typeof action !== 'undefined' && action.search(/Call Me/i) !== -1) {
                  var phone = "";
                  phone = this.ask.gives.find(
                    give => give._id === this.giveID
                  ).phoneNo;
                  if (phone && typeof phone !== 'undefined' && phone !== '') {
                    let callMessage = giveData.callMessage ? `${giveData.callMessage}` : ''
                    this.giveText = giveData.callText ? `${callMessage} \n Please call or text me at: ${phone}` : `${callMessage} \n My phone number is: ${phone}`;
                  }
                } else if (typeof action !== 'undefined' && action.search(/Let's Connect/i) !== -1) {
                  if (typeof insight !== 'undefined' && insight !== '') {
                    this.giveText = `\n\n<p>"${insight}"</p>`;
                  }
                }
              });
              this.give = this.ask.gives.find(give => give._id === this.giveID);
              var giveDate = this.give.when;
              this.giveDate = this.$moment(giveDate).format('MMMM DD, YYYY');
            }
          }
        });
      }
    },
    submitFeedback: async function() {
      // Prevent double submissions
      if (this._isSubmitting) {
        console.log('Already submitting, skipping duplicate call');
        return;
      }
      this._isSubmitting = true;
      
      try {
        if (this.feedback === 'request') {
          if (typeof this.giveID === 'undefined' || this.giveID === 'null' || this.giveID === 'undefined') {
            await this.api.post(`asks/feedback-request`, {
              askID: this.askID,
              email: this.email,
              comment: this.comment,
              testimonialConsent: this.testimonialConsent,
              num: this.num,
              feedback: this.feedback
            }).then(response => {
              if (response.data.error) {
                this.$validator.reset();
                this.email = '';
                this.comment = '';
                return this.$toast.error(response.data.error);
              }
              this.feedbackId = response.data.lastInsId;
              this.pushId = response.data.pushId;
            });
          } else {
            await this.api
            .post(`asks/feedback-request`, {
              feedbackRequestId: this.giveID,
              giveID: this.giveID,
              askID: this.askID,
              comment: this.comment,
              testimonialConsent: this.testimonialConsent,
              num: this.num,
              feedback: this.feedback
            }).then(response => {
              if (response.data.error) {
                this.$validator.reset();
                this.email = '';
                this.comment = '';
                return this.$toast.error(response.data.error);
              }
              this.feedbackId = response.data.lastInsId;
              this.pushId = response.data.pushId;
            });
          }
        } else if (this.feedback === 'response') {
          if (typeof this.askID === 'undefined' || this.askID === 'null' || this.askID === 'undefined') {
            await this.api
            .post(`asks/feedback-request`, {
              giveID: this.giveID,
              email: this.email,
              comment: this.comment,
              testimonialConsent: this.testimonialConsent,
              num: this.num,
              feedback: this.feedback
            }).then(response => {
              if (response.data.error) {
                this.$validator.reset();
                this.email = '';
                this.comment = '';
                return this.$toast.error(response.data.error);
              }
              this.feedbackId = response.data.lastInsId;
              this.pushId = response.data.pushId;
            });
          } else {
            await this.api
            .post(`asks/feedback-request`, {
              giveID: this.giveID,
              askID: this.askID,
              comment: this.comment,
              testimonialConsent: this.testimonialConsent,
              num: this.num,
              feedback: this.feedback
            }).then(response => {
              if (response.data.error) {
                this.$validator.reset();
                this.email = '';
                this.comment = '';
                return this.$toast.error(response.data.error);
              }
              this.feedbackId = response.data.lastInsId;
              this.pushId = response.data.pushId;
            });
          }
        }
      } finally {
        this._isSubmitting = false;
      }
    },
    updateFeedback: async function() {
      /*insert feedback when user comes from email , and on submit update that feedback with comment*/

      //Add a validation check to the feedback
      const isValid = await this.$validator.validateAll();
      if (!isValid) {
        return;
      }

      //Insert feedback
      if (this.pushId !== '') {
        let sentParameter = {};
        if (this.feedback === 'request') {
          if (typeof this.giveID === 'undefined' || this.giveID === 'null' || this.giveID === 'undefined') {
            sentParameter = {
              askID: this.askID,
              email: this.email,
              comment: this.comment,
              testimonialConsent: this.testimonialConsent,
              num: this.num,
              feedback: this.feedback,
              pushId: this.pushId,
              feedbackId: this.feedbackId
            }
            // await this.api
            // .post(`asks/update-feedback-request`, ).then(response => {
            //   if (response.data.error) {
            //     this.$validator.reset();
            //     this.email = '';
            //     this.comment = '';
            //     return this.$toast.error(response.data.error);
            //   }
            //   document.title = 'Thank You';
            //   this.success = true;
            //   window.scrollTo(0, 0);
            // });
          } else {
            sentParameter = {
              giveID: this.giveID,
              askID: this.askID,
              comment: this.comment,
              testimonialConsent: this.testimonialConsent,
              num: this.num,
              feedback: this.feedback,
              pushId: this.pushId,
              feedbackId: this.feedbackId
            }
            // await this.api
            // .post(`asks/update-feedback-request`, {
            //   giveID: this.giveID,
            //   askID: this.askID,
            //   comment: this.comment,
            //   testimonialConsent: this.testimonialConsent,
            //   num: this.num,
            //   feedback: this.feedback,
            //   pushId: this.pushId,
            //   feedbackId: this.feedbackId
            // }).then(response => {
            //   if (response.data.error) {
            //     this.$validator.reset();
            //     this.email = '';
            //     this.comment = '';
            //     return this.$toast.error(response.data.error);
            //   }
            //   document.title = 'Thank You';
            //   this.success = true;
            //   window.scrollTo(0, 0);
            // });
          }
        } else if (this.feedback === 'response') {
          if (typeof this.askID === 'undefined' || this.askID === 'null' || this.askID === 'undefined') {
            sentParameter = {
              giveID: this.giveID,
              email: this.email,
              comment: this.comment,
              testimonialConsent: this.testimonialConsent,
              num: this.num,
              feedback: this.feedback,
              pushId: this.pushId,
              feedbackId: this.feedbackId
            }
            // await this.api
            // .post(`asks/update-feedback-request`, {
            //   giveID: this.giveID,
            //   email: this.email,
            //   comment: this.comment,
            //   testimonialConsent: this.testimonialConsent,
            //   num: this.num,
            //   feedback: this.feedback,
            //   pushId: this.pushId,
            //   feedbackId: this.feedbackId
            // }).then(response => {
            //   if (response.data.error) {
            //     this.$validator.reset();
            //     this.email = '';
            //     this.comment = '';
            //     return this.$toast.error(response.data.error);
            //   }
            //   document.title = 'Thank You';
            //   this.success = true;
            //   window.scrollTo(0, 0);
            // });
          } else {
            sentParameter = {
              giveID: this.giveID,
              askID: this.askID,
              comment: this.comment,
              num: this.num,
              testimonialConsent: this.testimonialConsent,
              feedback: this.feedback,
              pushId: this.pushId,
              feedbackId: this.feedbackId
            }
            // await this.api
            // .post(`asks/update-feedback-request`, {
            //   giveID: this.giveID,
            //   askID: this.askID,
            //   comment: this.comment,
            //   num: this.num,
            //   testimonialConsent: this.testimonialConsent,
            //   feedback: this.feedback,
            //   pushId: this.pushId,
            //   feedbackId: this.feedbackId
            // }).then(response => {
            //   if (response.data.error) {
            //     this.$validator.reset();
            //     this.email = '';
            //     this.comment = '';
            //     return this.$toast.error(response.data.error);
            //   }
            //   document.title = 'Thank You';
            //   this.success = true;
            //   window.scrollTo(0, 0);
            // });
          }
        }
        document.title = 'Thank You';
        this.success = true;
        window.scrollTo(0, 0);
        await this.api.post(`asks/update-feedback-request`, sentParameter).then(response => {
          if (response.data.error) {
            this.$validator.reset();
            this.email = '';
            this.comment = '';
            return this.$toast.error(response.data.error);
          }
        });
      }
    },
    countdown: function() {
      this.remainingCount = this.max - this.comment.length;
      this.remainingCount === 0
        ? (this.exceedsMaxCount = true)
        : (this.exceedsMaxCount = false);
    }
  }
}
</script>
<style>
.testimonial-font {
  font-family: Roboto Slab;
  font-weight: 300;
  font-size: 14px;
  line-height: 18px;
  color: #1D1820;
  word-wrap: break-word;
  white-space: pre-line;
  margin-top: 15px;
  float:left;
}
</style>



// WEBPACK FOOTER //
// src/components/AddFeedback.vue